import React, { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Bars } from '@gravity-ui/icons';
import Sidebar from '../Sidebar/Sidebar';
import NewViolationBanner from '../NewViolationBanner/NewViolationBanner';
import PushOnboardingCard from '../PushOnboardingCard/PushOnboardingCard';
import { useForegroundViolationBanner } from '../../hooks/useForegroundViolationBanner';
import './MainLayout.css';

const MOBILE_BREAKPOINT = 768;

const MainLayout = () => {
  const [isMobile, setIsMobile] = useState(
    () => window.innerWidth <= MOBILE_BREAKPOINT
  );

  // ❗ Всегда закрыт по умолчанию
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { event: bannerEvent, dismiss: dismissBanner } = useForegroundViolationBanner();

  // Берём первый сегмент пути, а не последний: на вложенных маршрутах вроде
  // /violations/123 или /cameras/5/live последний сегмент не совпадает
  // ни с одним пунктом меню и подсветка пропадает.
  const getActiveViewFromPath = () => {
    const [, firstSegment] = location.pathname.split('/');
    return firstSegment || 'profile';
  };

  // Отслеживаем resize
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsMobile(mobile);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // На мобильных закрываем при смене страницы
  useEffect(() => {
    if (isMobile) {
      setIsSidebarVisible(false);
    }
  }, [location.pathname, isMobile]);

  // Блокируем скролл при открытом сайдбаре
  useEffect(() => {
    if (isSidebarVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isSidebarVisible]);

  const toggleSidebar = () => setIsSidebarVisible((v) => !v);
  const closeSidebar = () => setIsSidebarVisible(false);

  return (
    <div className="main-layout">
      {/* Кнопка открытия */}
      {!isSidebarVisible && (
        <button
          className="sidebar-toggle"
          onClick={toggleSidebar}
          aria-label="Открыть меню"
        >
          <Bars width={22} height={22} />
        </button>
      )}

      {/* ❗ ВСЕГДА рендерим sidebar */}
      <Sidebar
        activeView={getActiveViewFromPath()}
        onNavigate={(view) => navigate(`/${view}`)}
        onClose={closeSidebar}
        isMobile={isMobile}
        isVisible={isSidebarVisible}
      />

      {/* Контент */}
      <div className="content-area">
        <Outlet />
      </div>

      {/* Push onboarding и foreground fallback для iOS */}
      <PushOnboardingCard />
      {bannerEvent && <NewViolationBanner event={bannerEvent} onDismiss={dismissBanner} />}
    </div>
  );
};

export default MainLayout;
